import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { Icon } from '@iconify/react';

const Skills = () => {
  const { t } = useTranslation();

  const technologies = [
    { name: "React", icon: "logos:react" },
    { name: "Vue.js", icon: "logos:vue" },
    { name: "TypeScript", icon: "logos:typescript-icon" },
    { name: "JavaScript", icon: "logos:javascript" },
    // { name: "Next.js", icon: "logos:nextjs-icon" },
    { name: "Node.js", icon: "logos:nodejs-icon" },
    { name: "Laravel", icon: "logos:laravel" },
    { name: "PHP", icon: "logos:php" },
    { name: "Tailwind CSS", icon: "logos:tailwindcss-icon" },
    { name: "Bootstrap", icon: "logos:bootstrap" },
    { name: "PostgreSQL", icon: "logos:postgresql" },
    { name: "Docker", icon: "logos:docker-icon" },
    // { name: "AWS", icon: "logos:aws" },
    { name: "Git", icon: "logos:git-icon" },
    { name: "GitHub", icon: "logos:github-icon" },
    { name: "Vercel", icon: "logos:vercel-icon" },
    { name: "MySQL", icon: "logos:mysql-icon" },
    { name: "Figma", icon: "logos:figma" }
  ];

  // Duplicar os ícones para criar efeito infinito
  const duplicatedTechnologies = [...technologies, ...technologies];

  return (
    <section
      id="skills"
      className="py-16 relative overflow-hidden"
    >
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-1/4 left-10 w-64 h-64 bg-gradient-to-r from-cyan-500 to-blue-500 rounded-full blur-3xl"></div>
        <div className="absolute bottom-1/4 right-10 w-48 h-48 bg-gradient-to-r from-purple-500 to-pink-500 rounded-full blur-3xl"></div>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-gradient-to-r from-indigo-500/20 to-purple-500/20 rounded-full blur-3xl"></div>
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <motion.h2
          className="text-4xl md:text-6xl font-bold text-center text-white mb-12"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          {t('skills.title')}
        </motion.h2>

        {/* Carrossel de Ícones */}
        <div className="relative">
          <div className="overflow-hidden" style={{ maskImage: "linear-gradient(to right, transparent, black 10%, black 90%, transparent)" }}>
            <motion.div
              className="flex gap-8"
              animate={{ 
                x: [0, -100 * technologies.length] 
              }}
              transition={{
                x: {
                  repeat: Infinity,
                  repeatType: "loop",
                  duration: 20,
                  ease: "linear"
                }
              }}
              style={{ 
                willChange: "transform",
                backfaceVisibility: "hidden",
                transform: "translateZ(0)"
              }}
            >
              {duplicatedTechnologies.map((tech, index) => (
                <motion.div
                  key={`${tech.name}-${index}`}
                  className="flex-shrink-0 group"
                  whileHover={{ scale: 1.1, y: -5 }}
                  transition={{ type: "spring", stiffness: 400, damping: 25 }}
                  style={{ minWidth: "80px" }}
                >
                  <div className="relative">
                    <motion.div
                      className="w-20 h-20 md:w-24 md:h-24 flex items-center justify-center transition-all duration-300"
                      whileHover={{ scale: 1.05 }}
                    >
                      <Icon icon={tech.icon} className="w-14 h-14 md:w-16 md:h-16" />
                    </motion.div>
                    
                    {/* Tooltip com nome da tecnologia */}
                    <motion.div
                      className="absolute -bottom-12 left-1/2 transform -translate-x-1/2 px-3 py-1 bg-black/80 text-white text-sm rounded-lg whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                      initial={{ opacity: 0, y: 10 }}
                      whileHover={{ opacity: 1, y: 0 }}
                    >
                      {tech.name}
                      <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 rotate-45 w-2 h-2 bg-black/80"></div>
                    </motion.div>
                  </div>
                </motion.div>
              ))}
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Skills;